import {
	Box,
	Card,
	CardContent,
	Grid,
	Snackbar,
	Typography,
	makeStyles,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Alert, { Color } from '@material-ui/lab/Alert';
import { Constant } from 'src/shared/constants';
import { IVolumetricWeightRequest, IVolumetricWeightResponse } from 'src/models/volumetricWeight.models';
import VolumetricWeightForm from './volumetric-weight-form.component';
import { ToolsService } from 'src/services/tools.service';
import { WeightUnitEnum } from 'src/shared/enum';

export const useStyles = makeStyles({
	hidden: {
		display: 'none',
	},
	visible: {
		display: 'block',
	},
	paddingTop: {
		paddingTop: '120px',
	}
});

const VolumetricWeightTool: React.FC = () => {
	const { t } = useTranslation();
	const classes = useStyles();

	const [volumetricWeight, setVolumetricWeight] = useState<IVolumetricWeightResponse | null>(null);
	const [snackbarState, setSnackbarState] = useState<boolean>(false); // TODO: Use snackbar from global level and remove it from here
	const [snackbarMessage, setSnackbarMessage] = useState<string>('');
	const [severity, setSeverity] = useState<Color>(Constant.colorError);

	// Function to use getVolumetricWeight method of VolumetricWeightService and handle the response to show it onto the screen
	const getVolumetricWeight = async (value: IVolumetricWeightRequest) => {
		try {
			const res = await ToolsService.getVolumetricWeight(value);
			let geocoderFromResponse: IVolumetricWeightResponse = {
				volumetricWeight: res.data.volumetricWeight,
				volumetricWeightUnit: res.data.volumetricWeightUnit
			};

			// set the getVolumetricWeight API response in volumetricWeight to show the data on the UI
			setVolumetricWeight(geocoderFromResponse);
		} catch (error: any) {
			setSnackbarMessage(error);
			setSeverity(Constant.colorError);
			setSnackbarState(true);
		}
	};

	return (
		<>
			<Card>
				<CardContent>
					<Grid item container spacing={8}>
						{/* Form to enter the dimensions, carrier & service of the package to calculate volumetric weight using API*/}
						<Grid item sm={7}>
							<VolumetricWeightForm getVolumetricWeight={getVolumetricWeight} setVolumetricWeight={setVolumetricWeight} />	
						</Grid>

						{/* Output section where the output from the volumetricWeight API is shown, and if there is no data then this section is not displayed to user. */}
						<Grid item sm={5} className={volumetricWeight ? classes.visible : classes.hidden}>
							<Grid item container sm={12} className={classes.paddingTop}>
								<Grid item md={6} xl={4}>
									<Typography variant='h6' color='inherit'>
										<Box fontWeight='bold'>{t('label-volumetric-weight')}:</Box>
									</Typography>
								</Grid>
								<Grid item md={6} xl={8}>
									{volumetricWeight?.volumetricWeight ? (
										<Typography variant='h6' color='inherit'>
											<Box fontWeight='bold'>{volumetricWeight.volumetricWeight + ' ' + volumetricWeight.volumetricWeightUnit}</Box>
										</Typography>
									) : (
										<Typography variant='h6' color='inherit'>
											<Box fontWeight='bold'>{"N/A"}</Box>
										</Typography>
									)}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</CardContent>
			</Card>
			<Snackbar open={snackbarState} autoHideDuration={6000} onClose={() => setSnackbarState(false)}>
				<Alert severity={severity}>{snackbarMessage}</Alert>
			</Snackbar>
		</>
	);
};

export default VolumetricWeightTool;